<template>
    <div>
      <b-card>
        <b-tabs card fill>
          <b-tab>
            <template #title>
                <b-row><b-col align-self="center"><BIconExclamationTriangleFill  scale = 2 variant="warning"></BIconExclamationTriangleFill></b-col><b-col align="left"><h2><b-badge variant = "warning">{{ BreachCount }}</b-badge></h2></b-col></b-row>
                <b-row><b-col align="center">Compliance Breaches</b-col></b-row>
            </template>
            <b-card   v-if="this.breachlist.length == 0">
              You currently have no Notifications in this category
            </b-card>
            <b-card  v-if="this.breachlist.length > 0">
            <b-alert
              v-for="(id, idx) in this.breachlist"
              :key="idx"
              show
              class="breachalert"
              v-model="alertShow"
            >
            <b-row><b-col><h4>{{ id[0][2]}}</h4></b-col><b-col cols="4">Compliance Breaches: <b-avatar class="breach" >{{ id.length -1 }}</b-avatar></b-col><b-col align="right"><b-button variant="outline-dark" v-on:click="AlertDetail(id,'breach')">Details</b-button></b-col></b-row>
         </b-alert> 
         
        </b-card>
          </b-tab>
          <b-tab>
            <template #title>
              <b-row>
                <b-col><h2><b-badge variant = "danger">{{ HighCount }}</b-badge></h2></b-col></b-row>
                <b-row><b-col align="center">High Risk Notifications</b-col></b-row>
            </template>
            <b-card   v-if="this.highlist.length == 0">
              You currently have no Notifications in this category
            </b-card>
            <b-card  v-if="this.highlist.length > 0">
            <b-alert
              v-for="(id, idx) in this.highlist"
              :key="idx"
              show
              :variant= id.slice(-1)[0]
              v-model="alertShow"
            >
            <b-row><b-col><h4>{{ getNewName(id[0][1], id[0][10]) }}</h4></b-col><b-col cols="4">Total Device Alerts: <b-avatar :variant=id.slice(-1)[0] >{{ id.length -1 }}</b-avatar></b-col><b-col align="right"><b-button variant="outline-dark" v-on:click="AlertDetail(id,'alert')">Details</b-button></b-col></b-row>
         </b-alert> 
        </b-card>
          </b-tab>
          <b-tab>
            <template #title>
              <b-row>
                <b-col><h2><b-badge class="highrisk">{{ MedCount }}</b-badge></h2></b-col></b-row>
                <b-row><b-col align="center">Medium Risk Notifications</b-col></b-row>
            </template>
            <b-card   v-if="this.mediumlist.length == 0">
              You currently have no Notifications in this category
            </b-card>
            <b-card v-if="this.mediumlist.length > 0">
            <b-alert
              v-for="(id, idx) in this.mediumlist"
              :key="idx"
              show
              class="alertrisk"
              
              v-model="alertShow"
            >
            <b-row><b-col><h4>{{ getNewName(id[0][1], id[0][10]) }}</h4></b-col><b-col cols="4">Total Device Alerts: <b-avatar class="highrisk" >{{ id.length -1 }}</b-avatar></b-col><b-col align="right"><b-button variant="outline-dark" v-on:click="AlertDetail(id,'alert')">Details</b-button></b-col></b-row>
         </b-alert> 
        </b-card>
          </b-tab>
          <b-tab>
            <template #title>
              <b-row>
                <b-col><h2><b-badge variant = "info">{{ InfoCount }}</b-badge></h2></b-col></b-row>
                <b-row><b-col align="center">Info Notifications</b-col></b-row>
            </template>
            <b-card   v-if="this.infolist.length == 0">
              You currently have no Notifications in this category
            </b-card>
            <b-card   v-if="this.infolist.length > 0">
            <b-alert
              v-for="(id, idx) in this.infolist"
              :key="idx"
              show
              :variant= id.slice(-1)[0]
              v-model="alertShow"
            >
            <b-row><b-col><h4>{{ getNewName(id[0][1], id[0][10]) }}</h4></b-col><b-col cols="4">Total Device Alerts: <b-avatar :variant=id.slice(-1)[0] >{{ id.length -1 }}</b-avatar></b-col><b-col align="right"><b-button variant="outline-dark" v-on:click="AlertDetail(id,'alert')">Details</b-button></b-col></b-row>
         </b-alert> 
         </b-card>
          </b-tab>
          <b-tab title="Escalated">
            <template #title>
              <b-row>
                <b-col><h2><b-badge variant = "secondary">{{ EscCount }}</b-badge></h2></b-col></b-row>
                <b-row><b-col align="center">Escalated Notifications</b-col></b-row>
            </template>
            <b-card   v-if="this.escalatedlist.length == 0">
              You currently have no Notifications in this category
            </b-card>
            <b-card   v-if="this.escalatedlist.length > 0">
            <b-alert
              v-for="(id, idx) in this.escalatedlist"
              :key="idx"
              show
              variant= "secondary"
              v-model="alertShow"
            >
            <b-row><b-col><h4>{{ getNewName(id[0][1], id[0][10]) }}</h4></b-col><b-col cols="4">Total Device Alerts: <b-avatar variant="secondary" >{{ id.length -1 }}</b-avatar></b-col><b-col align="center"><b-badge variant="dark">ESCALATED</b-badge></b-col><b-col align="right"><b-button variant="outline-dark" v-on:click="AlertDetail(id,'alert')">Details</b-button></b-col></b-row>
         </b-alert> 
         </b-card>
          </b-tab>
          </b-tabs>
      </b-card>

      <b-modal
        ref="AlertDetailsModal"
        id="AlertDetailsModal"
        title="Alert Details"
        content-class="Modal"
        header-bg-variant="light"
        footer-bg-variant="light"
        lazy
        ok-only
        hide-footer>
        <b-card v-if="detaillist.length == 0">
          <b-row><b-col>Device Alerts</b-col></b-row>
          You have no more alerts for this device
        </b-card>
        <b-card v-if="detaillist.length > 0">
          <b-row><b-col>Device Alerts</b-col></b-row>
          <b-alert
              v-for="(id, idx) in detaillist"
              :key="idx"
              show
              variant= "light"
              v-model="alertShow"
            >
            <b-row v-if="id[9] == 'warning'" class="highrisk">
              <b-col> {{ id[0] }}</b-col><b-col>Probe: {{ id[11] }}</b-col>
              <b-col align="right"><b-button size="sm" variant="dark" v-on:click="AlertAction(id,'notification')" >Action</b-button></b-col>
            </b-row>
            <b-row v-if="id[9] == 'info'" class="infoalert">
              <b-col> {{ id[0] }}</b-col><b-col>Probe: {{ id[11] }}</b-col>
              <b-col align="right"><b-button size="sm" variant="dark" v-on:click="AlertAction(id,'notification')" >Action</b-button></b-col>
            </b-row>
            <b-row v-if="id[9] == 'danger'" class="dangeralert">
              <b-col> {{ id[0] }}</b-col><b-col>Probe: {{ id[11] }}</b-col>
              <b-col align="right"><b-button size="sm" variant="dark" v-on:click="AlertAction(id,'notification')" >Action</b-button></b-col>
            </b-row>
            <b-row><b-col>{{ id[4] }} - {{ id[5] }}</b-col></b-row>
            <b-row><b-col> {{ id[6] }}</b-col></b-row> 
            <b-row><b-col v-if="id[11] =='ESCALERT' || id[12] == 'ESCALERT'"><b-badge variant="dark">ESCALATED</b-badge></b-col></b-row>
            </b-alert>
        </b-card>
        <br />
        <b-row><b-col><b-button variant="outline-danger" v-on:click="CancelDetail('alert')">Cancel</b-button></b-col></b-row>
      </b-modal>

      <b-modal
        ref="BreachDetailsModal"
        id="BreachDetailsModal"
        title="Breach Details"
        content-class="Modal"
        header-bg-variant="light"
        footer-bg-variant="light"
        lazy
        ok-only
        hide-footer>
        <b-card v-if="detaillist.length == 0">
          <b-row><b-col>Compliance Breaches</b-col></b-row>
          You have no more breaches for this device
        </b-card>
        <b-card v-if="detaillist.length > 0">
          <b-row><b-col>Compliance Breaches</b-col></b-row>
          <b-alert
              v-for="(id, idx) in detaillist"
              :key="idx"
              show
              variant= "light"
              v-model="alertShow"
            >
            <b-row class="breach">
              <b-col> {{ id[0] }}</b-col><b-col>Probe: {{ id[11] }}</b-col>
              <b-col align="right"><b-button size="sm" variant="dark" v-on:click="AlertAction(id,'breach')" >Action</b-button></b-col>
            </b-row>
            <b-row><b-col>{{ id[4] }} - {{ id[5] }}</b-col></b-row>
            <b-row><b-col> {{ id[10] }}</b-col></b-row> 
            <b-row><b-col v-if="id[9] =='Escalated'"><b-badge variant="dark">ESCALATED</b-badge></b-col></b-row>
            </b-alert>
        </b-card>
        <br />
        <b-row><b-col><b-button variant="outline-danger" v-on:click="CancelDetail('breach')">Cancel</b-button></b-col></b-row>
      </b-modal>
      <b-modal
        ref="BreachActionModal"
        id="BreachActionModal"
        title="Breach Alert Action"
        content-class="Modal"
        header-bg-variant="light"
        footer-bg-variant="light"
        lazy
        ok-only
        hide-footer>
      <b-card>
        <b-card-body>
        <b-row class="breach"><b-col><h4>Compliance Breach</h4></b-col></b-row>
        <b-row><b-col>{{ actionalert[0] }}</b-col></b-row>
        <b-row><b-col>Probe: {{ actionalert[11] }}</b-col></b-row>
        <b-row><b-col>Raised: {{ actionalert[4] }} at {{ actionalert[5] }}</b-col></b-row>
        <b-row><b-col>{{ actionalert[10] }}</b-col></b-row>
      </b-card-body>
      </b-card>
      <hr/>
      <Recommendations :Type='Type' :Specific='Specific' />
      <b-card v-if="this.showclosure">
        Breach will be closed and line added to the virtual logbook to track closure.
        <b-form-textarea
      id="textarea"
      v-model="closurenote"
      placeholder="Please Provide a Closure Note for the breach..."
      rows="3"
      max-rows="3"
    ></b-form-textarea>
        <b-row><b-col><b-button variant="outline-info" v-on:click="CloseBreach(actionalert,'Confirm')">Close</b-button></b-col></b-row>
      </b-card>
      <b-card v-if="this.showescalate">
        <b-row><b-col>Please confirm that you wish to escalate this alert for review</b-col></b-row>
        <b-form-textarea
      id="textarea"
      v-model="escalationnote"
      placeholder="Please Provide an escalation reason for the alert..."
      rows="3"
      max-rows="3"
    ></b-form-textarea>
        <b-row><b-col><b-button variant="outline-info" v-on:click="EscalateBreach(actionalert,'Confirm')">Escalate Breach</b-button></b-col></b-row>
      </b-card>
      <br />
      <b-row v-if="!this.showclosure && !this.showescalate && actionalert[9] != 'info'"><b-col><b-button variant="outline-info" v-on:click="CloseBreach(actionalert,'Details')">Close Breach</b-button></b-col>
        <b-col v-if="actionalert[9]!='Escalated'"><b-button variant="outline-info" v-on:click="EscalateBreach(actionalert,'Details')">Escalate Breach</b-button></b-col><b-col v-if="actionalert[9]=='Escalated'"><b-badge variant="dark">ESCALATED</b-badge></b-col></b-row>
         <b-row><b-col><b-button variant="outline-danger" v-on:click="CancelAction('breach')">Cancel</b-button></b-col></b-row>
     
    </b-modal>
    
      <b-modal
        ref="ActionModal"
        id="ActionModal"
        title="Alert Action"
        content-class="Modal"
        header-bg-variant="light"
        footer-bg-variant="light"
        lazy
        ok-only
        hide-footer>
      <b-card>
        <b-card-body>
        <b-row v-if="actionalert[9] == 'info'" class="infoalert"><b-col><h4>Information</h4></b-col></b-row>
        <b-row v-if="actionalert[9] == 'warning'" class="highrisk"><b-col><h4>Medium Priority</h4></b-col></b-row>
        <b-row v-if="actionalert[9] == 'danger'" class="dangeralert"><b-col><h4>High Priority</h4></b-col></b-row>
        <b-row><b-col>{{ actionalert[0] }}</b-col></b-row>
        <b-row><b-col>Probe: {{ actionalert[11] }}</b-col></b-row>
        <b-row><b-col>Raised: {{ actionalert[4] }} at {{ actionalert[5] }}</b-col></b-row>
        <b-row><b-col>{{ actionalert[6] }}</b-col></b-row>
      </b-card-body>
      </b-card>
      <hr/>
      <Recommendations :Type='Type' :Specific='Specific' />
      <b-card v-if="actionalert[9] == 'info'">
        Acknowledge and close information Alert
        <b-row><b-col><b-button variant="outline-info" v-on:click="AcknowledgeInfo(actionalert)">Acknowledge</b-button></b-col></b-row>
      </b-card>
      <b-card v-if="this.showclosure">
        Alert will be closed and line added to the virtual logbook to track closure.
        <b-form-textarea
      id="textarea"
      v-model="closurenote"
      placeholder="Please Provide a Closure Note for the alert..."
      rows="3"
      max-rows="3"
    ></b-form-textarea>
        <b-row><b-col><b-button variant="outline-info" v-on:click="CloseAction(actionalert,'Confirm')">Close</b-button></b-col></b-row>
      </b-card>
      <b-card v-if="this.showescalate">
        <b-row><b-col>Please confirm that you wish to escalate this alert for review</b-col></b-row>
        <b-form-textarea
      id="textarea"
      v-model="escalationnote"
      placeholder="Please Provide an escalation reason for the alert..."
      rows="3"
      max-rows="3"
    ></b-form-textarea>
        <b-row><b-col><b-button variant="outline-info" v-on:click="EscalateAction(actionalert,'Confirm')">Escalate Alert</b-button></b-col></b-row>
      </b-card>
      <br />
      <b-row v-if="!this.showclosure && !this.showescalate && actionalert[9] != 'info'"><b-col><b-button variant="outline-info" v-on:click="CloseAction(actionalert,'Details')">Close Alert</b-button></b-col>
        <b-col v-if="actionalert[12]!='ESCALERT'"><b-button variant="outline-info" v-on:click="EscalateAction(actionalert,'Details')">Escalate Alert</b-button></b-col><b-col v-if="actionalert[12] == 'ESCALERT'"><b-badge variant="dark">ESCALATED</b-badge></b-col></b-row>
         <b-row><b-col><b-button variant="outline-danger" v-on:click="CancelAction('notification')">Cancel</b-button></b-col></b-row>
     
    </b-modal>
    <b-modal
      ref="LoadingModal"
      id="LoadingModal"
      content-class="Modal"
      hide-footer
      hide-header-close
      no-close-on-backdrop
      no-close-on-esc
      size="xl"
      centered
      hide-header
    >
    <div class="container_row" >
        <div class="layer2">
          <h1 class="HeadingText1">Loading Data...</h1>

          <img
            class="Logo"
            alt="Angelguard logo"
            src="../../assets/LogoOnly.png"
          />
        </div>
    </div>
</b-modal>
    </div>
  </template>
  
  <script>
import axios from "axios";
// import Vue from "vue";
import { IDToHuman } from "@/CustomFunctions/HumanName.js";
import { UTCToTimeZone } from "@/CustomFunctions/Timezone.js";
import Recommendations from "./Recommendations.vue";
import { BIconExclamationTriangleFill } from "bootstrap-vue/dist/bootstrap-vue.esm";

  export default {
    data(){
      return{
      response: null,
      Values: null,
      c1items: [],
      o1items: [],
      escarray: [],
      breres:[],
      res: [],
      res2:[],
      escres:[],
      alertslist:[],
      highlist:[],
      mediumlist:[],
      infolist:[],
      successlist:[],
      escalatedlist:[],
      breachlist:[],
      detaillist:[],
      actionalert: [],
      showclosure: false,
      showescalate: false,
      closurenote:"",
      escalationnote: "",
      escalationContact: "",
      UserName: localStorage.getItem("fullname"),
      HighCount: "-",
      MedCount: "-",
      InfoCount:"-",
      EscCount: "-",
      BreachCount: "-",
      matchedESCDevices: [],
      matchESCAlerts: [],
      modal: false,
      Note: "",
      Company: this.$Company,
      UserURN: this.$UserURN,
      buttonCooldown: false,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      variantColor: "success",
      notiAction: "",
      notiCategory: "",
      notiDate: "",
      notiDeviceID: "",
      notiID: "",
      notiInitiated: "",
      notiLevel: "",
      notiLocation: "",
      notiNote: "",
      notiTime: "",
      notiVariant: "",
      notiType: "",
      alertShow: "",
      loaded: false,
      screenWidth: 0,
      DeviceIDToChange: { C1: [], O1: [] },

      IDsIhaveChanged: { C1: [], O1: [] },
      IDsToChange: { C1: [], O1: [] },
      Type: '',
      Specific: ''

        }
    },
    mounted(){
      this.loaded = false

      let EscContactURL =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let EscContactHeaders = this.$apikeyPost;
    let EscContactRequest = {
      RequestType: "EscalationContact",
      FilterType: "",
      Company: "",
      Location: this.selectedlocation,
      Category: "",
      Level: "",
    };

    axios.post(EscContactURL, EscContactRequest, EscContactHeaders).then((response) => {

      if(response.data.Values.length == 0){
        this.escalationContact = "support@seraphprotect.online"
      } else{
      this.escalationContact = response.data.Values[0][1]
      }

    });

    let BreachLookUpURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/alertlookups";
        let BreachLookUpHeaders = this.$apikeyPost;
        let BreachLookUpRequest = {
          RequestType: "Breach",
          FilterType: "",
          Company: "",
          Location: this.selectedlocation,
          Category: "",
          Level: "",
        };

        axios.post(BreachLookUpURL, BreachLookUpRequest, BreachLookUpHeaders).then((response) => {
          let responseArray = response.data.Values

          this.breres = Object.groupBy(responseArray,b => b[1])

          this.getLevel(this.breres);

          });
    
      let LookUpURL =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/alertlookups";
    let LookUpHeaders = this.$apikeyPost;
    let LookUpRequest = {
      RequestType: "Filter",
      FilterType: "Location",
      Company: "",
      Location: this.selectedlocation,
      Category: this.SearchCategory,
      Level: this.SearchAlert,
    };

    axios.post(LookUpURL, LookUpRequest, LookUpHeaders).then((response) => {

      this.c1array = response.data.Values.C1;
      this.o1array = response.data.Values.O1;
      this.escarray = response.data.Values.ESC;

      for (let x = 0; x<this.escarray.length; x++){
        if(this.escarray[x][0].startsWith("BR")){
          let Var1 = this.escarray.indexOf(this.escarray[x])
          this.escarray.splice(Var1,1)
        }
      }

      this.escres = Object.groupBy(this.escarray, e => e[2]);

      this.res = Object.groupBy(this.c1array, c => c[1]);

      this.getLevel(this.res);

        for (let i = 0; i < this.c1array.length; i++) {
            this.IDGetArrays(this.c1array[i][1], "C1");
          }
        

      this.res2 = Object.groupBy(this.o1array,o => o[1]);

      this.getLevel(this.res2);

      this.matchedESCDevices =[]
      this.matchESCAlerts =[]

      this.getEscalated(this.highlist,'High')
      this.RemoveDuplicates("High")
      this.getEscalated(this.mediumlist,"Medium")
      this.RemoveDuplicates("Medium")

      this.HighLightEscalated()


        for (let i = 0; i < this.o1array.length; i++) {
            this.IDGetArrays(this.o1array[i][1], "O1");
          }
  
       this.SwitchToHuman("C1");
       this.SwitchToHuman("O1");
       this.refreshCounts();
       this.loaded = true;

    });
 
  },
    
    computed: {},
    components:{
        Recommendations,
        BIconExclamationTriangleFill
    },
    methods: {

      UpdatedLists(){
        
      this.loaded = false


      let BreachLookUpURL =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/alertlookups";
        let BreachLookUpHeaders = this.$apikeyPost;
        let BreachLookUpRequest = {
          RequestType: "Breach",
          FilterType: "",
          Company: "",
          Location: this.selectedlocation,
          Category: "",
          Level: "",
        };

        axios.post(BreachLookUpURL, BreachLookUpRequest, BreachLookUpHeaders).then((response) => {
          let responseArray = response.data.Values
          this.breachlist = []

          this.breres = Object.groupBy(responseArray,b => b[1])

          this.getLevel(this.breres);

          });

        let LookUpURL =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/alertlookups";
    let LookUpHeaders = this.$apikeyPost;
    let LookUpRequest = {
      RequestType: "Filter",
      FilterType: "Location",
      Company: "",
      Location: this.selectedlocation,
      Category: this.SearchCategory,
      Level: this.SearchAlert,
    };

    axios.post(LookUpURL, LookUpRequest, LookUpHeaders).then((response) => {
      this.loaded = true;
      this.highlist = []
      this.mediumlist = []
      this.infolist = []
      this.alertslist = []
      this.escalatedlist = []


      this.c1array = response.data.Values.C1;
      this.o1array = response.data.Values.O1;
      this.escarray = response.data.Values.ESC;

      this.escres = Object.groupBy(this.escarray, e => e[2]);

      this.res = Object.groupBy(this.c1array, c => c[1]);

      this.getLevel(this.res);

        for (let i = 0; i < this.c1array.length; i++) {
            this.IDGetArrays(this.c1array[i][1], "C1");
          }
        

      this.res2 = Object.groupBy(this.o1array,o => o[1]);

      this.getLevel(this.res2);

      this.matchedESCDevices =[]
      this.matchESCAlerts =[]

      this.getEscalated(this.highlist,'High')
      this.RemoveDuplicates("High")
      this.getEscalated(this.mediumlist,"Medium")
      this.RemoveDuplicates("Medium")

      this.HighLightEscalated()


        for (let i = 0; i < this.o1array.length; i++) {
            this.IDGetArrays(this.o1array[i][1], "O1");
          }
  
       this.SwitchToHuman("C1");
       this.SwitchToHuman("O1");
       this.refreshCounts();
       this.loaded = true
      });
    },

      getLevel(list){
        let mylist = list
        
        for (const entry of Object.values(mylist)) {

          let AlertValues = []
          for (let z = 0; z<entry.length; z++){
            AlertValues.push(entry[z][9])
          }

          let AlertLevel = "breach"

          if(AlertValues.includes(4)){
            AlertLevel = "info"
          }
          if(AlertValues.includes(2)){
            AlertLevel = "warning"
          }
          if (AlertValues.includes(3)){
            AlertLevel = "danger"
          } 

          entry.push(AlertLevel)

          if(entry.slice(-1)[0] == "danger"){
            this.highlist.push(entry)
          } else if (entry.slice(-1)[0] == "warning"){
            this.mediumlist.push(entry)
          } else if (entry.slice(-1)[0] == "info"){
            this.infolist.push(entry)
          } else if (entry.slice(-1)[0] == "breach"){
            this.breachlist.push(entry)
          }
          else{
            this.successlist.push(entry)
          }

 
          this.alertslist.push(entry)

        }
      },

      getEscalated(list,level){

        let TempAlertArray = []

        for (const item of Object.values(this.escres)) {
          for (let w = 0; w< item.length;w++)
          TempAlertArray.push(item[w][0])
        }

        let listforCheck = list
  

        if(level == "High"){
          for(let x= 0; x < listforCheck.length;x++){
            if(listforCheck[x][0][1] in this.escres){
            this.escalatedlist.push(listforCheck[x])

            this.matchedESCDevices.push(listforCheck[x][0][1])

            for(let y = 0; y < listforCheck[x].length;y++){            
              if(TempAlertArray.includes(listforCheck[x][y][0])){
                this.matchESCAlerts.push(listforCheck[x][y][0])
              }
            }

          } else{
            continue;
          }
        }
        }

        if(level == "Medium"){
          for(let x= 0; x < listforCheck.length;x++){
            if(listforCheck[x][0][1] in this.escres){
            this.escalatedlist.push(listforCheck[x])

            this.matchedESCDevices.push(listforCheck[x][0][1])

            for(let y = 0; y < listforCheck[x].length;y++){            
              if(TempAlertArray.includes(listforCheck[x][y][0])){
                this.matchESCAlerts.push(listforCheck[x][y][0])
              }
            }

          } else{
            continue;
          }
        }
        }
      },

      RemoveDuplicates(level){
        if(level == "High"){
          if(this.matchedESCDevices.length == 0){
            return
          } else {
            for(let x = 0; x < this.highlist.length;x++){
            if(this.matchedESCDevices.includes(this.highlist[x][0][1])){
              let highindex = this.highlist.indexOf(this.highlist[x])
              if (highindex > -1) { // only splice array when item is found
              this.highlist.splice(highindex, 1); // 2nd parameter means remove one item only
            }
            }           
          }
        
          }
        }
        if(level == "Medium"){
          if(this.matchedESCDevices.length == 0){
            return
          } else {
          for(let z = 0; z < this.mediumlist.length;z++){
            if(this.matchedESCDevices.includes(this.mediumlist[z][0][1])){
              let medindex = this.mediumlist.indexOf(this.mediumlist[z])
              if (medindex > -1) { // only splice array when item is found
              this.mediumlist.splice(medindex, 1); // 2nd parameter means remove one item only
            }
            }           
          }
          }
        }
      },
      HighLightEscalated(){
        for(let v = 0; v < this.escalatedlist.length;v++){
          for(let x = 0; x < this.escalatedlist[v].length;x++){
            if(this.matchESCAlerts.includes(this.escalatedlist[v][x][0])){
              this.escalatedlist[v][x].push("ESCALERT")
            }
          }
        }
      },

      AlertDetail(id,level){
        this.detaillist = []
        this.detaillist = id
        if(level != "breach"){
        this.detaillist = this.detaillist.slice(0,-1)
        for(let x = 0; x < this.detaillist.length; x++){

            if(this.detaillist[x][9] == 3 || this.detaillist[x][9] == "danger"){
              this.detaillist[x][9] = "danger"
          } else if (this.detaillist[x][9] == 2 || this.detaillist[x][9] == "warning"){
              this.detaillist[x][9] = "warning"
          } else if (this.detaillist[x][9] == 4 || this.detaillist[x][9] == "info"){
              this.detaillist[x][9] = "info"
          } else{
              this.detaillist[x][9] = "success"
          }
        } 
        this.$refs["AlertDetailsModal"].show(this.detaillist);
        }
        else{
          this.detaillist = this.detaillist.slice(0,-1)
          this.$refs["BreachDetailsModal"].show(this.detaillist)
        }



      },
      CloseBreach(id,stage){
        let devicenote = ""
        devicenote = this.closurenote
        this.closurenote = ""
        this.showclosure = false
        if(stage == 'Details'){
          this.showclosure = true
        } else if(stage == 'Confirm'){
          if(devicenote == ""){
            alert("Please complete the note field before closure")
            this.showclosure = true
          } else{

          let LookUpRequest = {
          Actions: ["Complete"],
          RequestID: id[0],
          ActionedBy: this.UserURN,
          StatusMsg: devicenote,
          NewStatus: ""
        };
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/breachactions";
        let LookUpHeaders = this.$apikeyPost;


         axios
           .post(LookUpUrl, LookUpRequest, LookUpHeaders)
           .then((response) => {
             response;
             alert(
                 "Breach " +
                 id[0] +
                 " has been Acknowledged and will be removed from list")
              
             const index = this.detaillist.indexOf(id)

             if (index > -1) { // only splice array when item is found
              this.detaillist.splice(index, 1); // 2nd parameter means remove one item only
              }
            
             this.UpdatedLists()
             this.$refs["BreachActionModal"].hide();
             this.devicenote = ""
           })
            if (id[9]== 'Escalated'){
              this.CloseEscalated(id)
            } 
            }
          
        }
      },
      CloseAction(id,stage){
        let devicenote = ""
        devicenote = this.closurenote
        this.closurenote = ""

        this.showclosure= false
        if (stage == "Details"){
          this.showclosure = true
        } else if(stage == "Confirm"){
          if(devicenote == ""){
            alert("Please complete the note field before closure")
            this.showclosure = true
          }
          else{
          let LookUpRequest = {
          Actions: ["Complete"],
          RequestID: id[0],
          ActionedBy: this.UserURN,
          StatusMsg: devicenote,
          NewStatus: ""
        };
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/alertactions";
        let LookUpHeaders = this.$apikeyPost;


         axios
           .post(LookUpUrl, LookUpRequest, LookUpHeaders)
           .then((response) => {
             response;
             alert(
                 "Notification " +
                 id[0] +
                 " has been Completed and will be removed from list")
              
             const index = this.detaillist.indexOf(id)

             if (index > -1) { // only splice array when item is found
              this.detaillist.splice(index, 1); // 2nd parameter means remove one item only
              }
            
             this.UpdatedLists()
             this.$refs["ActionModal"].hide();
             this.devicenote = ""
           })
            
           if (id.includes('ESCALERT') ){
              this.CloseEscalated(id)
            } 
              
          }
        
        }
      },
      AlertAction(id,alerttype){
        this.actionalert = [];
        this.actionalert = id
        if(alerttype == 'notification'){
        if (id[9] == 'info'){
          this.Type = id[9]
        } else{
          this.Type = id[7]
        }

        this.$refs["ActionModal"].show(this.actionalert);}
        else if (alerttype == 'breach'){
          this.Type = id[6]
          this.$refs['BreachActionModal'].show(this.actionalert)  
          this.Specific = ''
          this.Specific = id[7]
          // Specifics List 
          // HotMin
          // HotRet
          // ColdMax
          // ColdMin
          // ColdSupply
          // Flow
          // Mix
          // HotMax
          // Combi
          // POUMin
          // POUMax
          // CalorOut
          // CalorRet
          // HotMax
          
        }

      },
      EscalateBreach(id,stage){
        let escalatenote = ""
        escalatenote = this.escalationnote
        this.escalationnote = ""
        this.showescalate = false
        if (stage == "Details"){
          this.showescalate = true
        } else if(stage == "Confirm"){
          if(escalatenote == ""){
            alert("Please complete the note field before escalation")
            this.showescalate = true
          }
          else{
            let LookUpRequest = {
            Actions: ["Escalate"],
            RequestID: id[0],
            ActionedBy: this.UserURN,
            StatusMsg: escalatenote,
            NewStatus: "",
              };

        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/breachactions";
        let LookUpHeaders = this.$apikeyPost;


         axios
           .post(LookUpUrl, LookUpRequest, LookUpHeaders)
           .then((response) => {
             response;
             alert(
                 "Breach " +
                 id[0] +
                 " has been escalated to your location escalation contact for review")

            this.$refs["BreachActionModal"].hide();
      
          })
        }}
        let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";
        let EmailData = {
          ToEmail: this.escalationContact,
          EmailText:
            "The following breach has been escalated for review. \\n\\nBreachID: " +
            id[0] +
            "\\nDevice: " +
            id[1] +
            "\\n\\nEscalation Reason: " +
              escalatenote +
            "\\n\\nAlert Trigger: " +
            id[7]+
            "\\n\\nAlert Text: " +
            id[6] +
            "\\n\\nSent from Seraph Protect",
          EmailSubject: "System Alert " + id[0] + " Escalated",
        };

        let EmailPostHeaders = this.$apikeyPost;


        axios
          .post(EmailPosturl, EmailData, EmailPostHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => {
            "Error: ===", err;
          });
        this.$refs["BreachDetailsModal"].hide();
        this.UpdatedLists();
        this.escalatenote = ""
          
      },
      EscalateAction(id,stage){

        let escalatenote = ""
        escalatenote = this.escalationnote
        this.escalationnote = ""
        this.showescalate = false
        if (stage == "Details"){
          this.showescalate = true
        } else if(stage == "Confirm"){
          if(escalatenote == ""){
            alert("Please complete the note field before escalation")
            this.showescalate = true
          }
          else{

          let LookUpRequest = {
          Actions: ["Escalate"],
          RequestID: id[0],
          ActionedBy: this.UserURN,
          StatusMsg: escalatenote,
          NewStatus: "",
        };

        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/alertactions";
        let LookUpHeaders = this.$apikeyPost;

         axios
           .post(LookUpUrl, LookUpRequest, LookUpHeaders)
           .then((response) => {
             response;
             alert(
                 "Notification " +
                 id[0] +
                 " has been escalated to your location escalation contact for review")
            
             this.$refs["ActionModal"].hide();
           })

          let EmailPosturl =
          "https://d9py0urct8.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/emailgateway";
        let EmailData = {
          ToEmail: this.escalationContact,
          EmailText:
            "The following notification has been escalated for review. \\n\\nAlertID: " +
            id[0] +
            "\\nDevice: " +
            id[1] +
            "\\n\\nEscalation Reason: " +
              escalatenote +
            "\\n\\nAlert Trigger: " +
            id[7]+
            "\\n\\nAlert Text: " +
            id[6] +
            "\\n\\nSent from Seraph Protect",
          EmailSubject: "System Alert " + id[0] + " Escalated",
        };
        let EmailPostHeaders = this.$apikeyPost;

        axios
          .post(EmailPosturl, EmailData, EmailPostHeaders)
          .then((response) => {
            response;
          })
          .catch((err) => {
            "Error: ===", err;
          });
          this.$refs["AlertDetailsModal"].hide()
          this.UpdatedLists()

      }
    }
          this.escalatenote = ""

        },
        CloseEscalated(id){

          let CloseRequest = {
          Actions: ["CompleteEscalated"],
          RequestID: id[0],
          ActionedBy: "",
          StatusMsg: "",
          NewStatus: "",
        };
        let Urlpost = ""
        if (id[0].startsWith('BR',0)){
          Urlpost = "/breachactions"
        } else{
          Urlpost = "/alertactions"
        }
        let CloseUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          Urlpost;
        let CloseHeaders = this.$apikeyPost;


         axios
           .post(CloseUrl, CloseRequest, CloseHeaders)
           .then((response) => {
             response;
           })



        },
        AcknowledgeInfo(id){

          let LookUpRequest = {
          Actions: ["Acknowledge"],
          RequestID: id[0],
          ActionedBy: this.UserURN,
        };
        let LookUpUrl =
          "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
          this.$environment +
          "/alertactions";
        let LookUpHeaders = this.$apikeyPost;

        axios
          .post(LookUpUrl, LookUpRequest, LookUpHeaders)
          .then((response) => {
            response;
            alert(
                "Notification " +
                id[0] +
                " has been acknowledged and will no longer be actionable")

            const index = this.detaillist.indexOf(id)

            if (index > -1) { // only splice array when item is found
            this.detaillist.splice(index, 1); // 2nd parameter means remove one item only
            }
            this.UpdatedLists()
            this.$refs["ActionModal"].hide();
          })
        },
        
      CancelDetail(type){
        this.detaillist = []
        this.showclosure = false
        this.showescalate = false
        if(type == 'breach'){
          this.$refs["BreachDetailsModal"].hide();
        }
        else{
        this.$refs["AlertDetailsModal"].hide();
        }
        this.UpdatedLists()
      },
      CancelAction(type){
        this.actionalert = []
        this.showclosure = false
        this.showescalate = false
        if(type == 'breach'){
          this.$refs['BreachActionModal'].hide();

        }else{
        this.$refs["ActionModal"].hide();
        }
      },

      UpdateTimeDate(Date, Time) {
      let timeDate = UTCToTimeZone(Date, Time);
      return timeDate;
    },
    async SwitchToHuman(Type) {
      if (Type == "O1") {
        let Names = await IDToHuman(this.IDsToChange.O1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.O1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.O1.push({
            ID: this.IDsToChange.O1[q],
            Name: Names[q],
          });
        }
      }

      if (Type == "C1") {
        let Names = await IDToHuman(this.IDsToChange.C1, Type);

        for (let q = 0; q < Names.length; q++) {
          this.IDsIhaveChanged.C1.push(this.IDsToChange[q]);
          this.DeviceIDToChange.C1.push({
            ID: this.IDsToChange.C1[q],
            Name: Names[q],
          });
        }
      }
    },
    getNewName(data, Type) {
      Type = Type.replace("-", "");
      if (Type == "O1") {
        for (let i = 0; i < this.DeviceIDToChange.O1.length; i++) {
          if (data == this.DeviceIDToChange.O1[i].ID) {
            return this.DeviceIDToChange.O1[i].Name;
          }
        }
      } else if (Type == "C1") {
        for (let i = 0; i < this.DeviceIDToChange.C1.length; i++) {
          if (data == this.DeviceIDToChange.C1[i].ID) {
            return this.DeviceIDToChange.C1[i].Name;
          }
        }
      }
      return data.ID;
    },
    async IDGetArrays(ID, Type) {
      if (Type == "C1") {
        if (
          this.IDsIhaveChanged.C1.includes(ID) ||
          this.IDsToChange.C1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.C1.includes(ID) == false &&
          this.IDsToChange.C1.includes(ID) == false
        ) {
          this.IDsToChange.C1.push(ID);
        }
      }
      if (Type == "O1") {
        if (
          this.IDsIhaveChanged.O1.includes(ID) ||
          this.IDsToChange.O1.includes(ID)
        ) {
          return;
        } else if (
          this.IDsIhaveChanged.O1.includes(ID) == false &&
          this.IDsToChange.O1.includes(ID) == false
        ) {
          this.IDsToChange.O1.push(ID);
        }
      }
    },
    Showloader() {
      if (this.loaded) {
        this.$bvModal.hide("LoadingModal");
      } else if (this.loaded == false) {
        this.$bvModal.show("LoadingModal");
      }
    },

    refreshCounts() {
      this.HighCount = this.highlist.length
      this.MedCount = this.mediumlist.length
      this.InfoCount = this.infolist.length
      this.EscCount = this.escalatedlist.length
      this.BreachCount = this.breachlist.length
    }
    
    },
    watch: {
      loaded() {
      this.Showloader();
    },
    },
  };
  </script>
  <style scoped>
  .actionButton {
    display: block;
    margin: auto;
  }
  .idtext {
    margin-top: 5px;
    font-size: small;
    margin-bottom: 5px;
    font-weight: bold;
  }
  .notetext {
    margin-top: 5px;
    font-size: small;
    margin-bottom: 5px;
  }
  .content {
    text-align: center;
  }
.layer1,
.layer2 {
  grid-column: 1;
  grid-row: 1;
  background-color: rgb(109, 136, 195);
  opacity: 0.5;
}
.layer1 span {
  display: grid;
  place-items: center;
}

.Logo {
  scale: 150%;
  margin-top: 5rem;
  width: 15%;
  min-width: 150px;
}

.breach{
  background-color: #ffc107;
  color: black;
}
.breachalert{
  color: black;
    background-color: rgb(255,193,7,0.40);
    border-color: black;
    border-width: 2px;
}
.breachalert2{
  color: #525252ba;
    background-color: #fefefe;
    border-color: black;
    border-width: 2px;
}
.alertrisk{
  background-color: rgb(240, 94, 22, 0.50);
  color: #A4400E
}
.alert-light {
    color: #525252;
    background-color: #fefefe;
    border-color: #818182;
}
.infoalert{
  background-color: #17a2b8;
  color: black;
}
.dangeralert{
  background-color: #dc3545;
  color: black;
}

  </style>